import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tovo-infodialog',
  templateUrl: './infodialog.component.html',
  styleUrls: ['./infodialog.component.scss']
})
export class InfodialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
